import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Backfill from './pages/Backfill';
import Gaps from './pages/Gaps';
import BetaSpread from './pages/BetaSpread';
import StrategySubscriptions from './pages/StrategySubscriptions';
import SymbolMapping from './pages/SymbolMapping';

// Placeholder for Health Status (Phase 13)
const HealthStatus = () => (
  <Layout>
    <div>
      <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>Health Status</h1>
      <p style={{ color: '#94a3b8' }}>Coming Soon...</p>
    </div>
  </Layout>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />

        <Route path="/backfill" element={
          <ProtectedRoute>
            <Backfill />
          </ProtectedRoute>
        } />

        <Route path="/gaps" element={
          <ProtectedRoute>
            <Gaps />
          </ProtectedRoute>
        } />

        <Route path="/betaspread" element={
          <ProtectedRoute>
            <BetaSpread />
          </ProtectedRoute>
        } />

        <Route path="/strategies" element={
          <ProtectedRoute>
            <StrategySubscriptions />
          </ProtectedRoute>
        } />

        <Route path="/symbols" element={
          <ProtectedRoute>
            <SymbolMapping />
          </ProtectedRoute>
        } />

        <Route path="/health" element={
          <ProtectedRoute>
            <HealthStatus />
          </ProtectedRoute>
        } />

        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
